export const capitalize = (s: string) => {
  if (s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  throw { error: 'No string to capitalise' };
};
